const Horn = Mach.requireModule('SLCHorn');
const SLCompass = Mach.requireModule('SLCompass');

function getRatingPopupAndDiscountHorn() {
  const config = Horn?.getAppConfig() || {};
  const compassInfo = SLCompass?.getCompassInfo?.() || {};
  const actualCompassInfo = SLCompass?.getActualCompassInfo?.() || {};
  const enableRatingPopup = compassInfo.region === 'HK' || actualCompassInfo.actualRegion === 'HK';
  return config.enableRatingPopupAndDiscount || { enableRatingPopup };
}
export {
  getRatingPopupAndDiscountHorn
};
